import { AsyncPipe } from "@angular/common";
import { Component, ChangeDetectionStrategy, Signal } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import {
  FooterComponent,
  BreadcrumbComponent,
  HeaderComponent,
  SideNavComponent,
} from "@components";
import { FuturesModeService } from "@services";
import { LoadingTrackerService } from "src/app/core/service/loading-track.service";
import { FuturesFooterComponent } from "src/app/futures/footer/futures-footer.component";
import { LoaderComponent } from "../../components/loader/loader.component";

@Component({
  selector: "app-main-layout",
  templateUrl: "./main-layout.component.html",
  styleUrls: ["./main-layout.component.scss"],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    SideNavComponent,
    HeaderComponent,
    BreadcrumbComponent,
    RouterOutlet,
    FooterComponent,
    FuturesFooterComponent,
    AsyncPipe,
    LoaderComponent,
  ],
})
export class MainLayoutComponent {
  public globalLoaderState = this._loadingTrackerService.globalLoaderState$;

  public readonly isFuturesRoute: Signal<boolean> = this._futuresModeService.isFuturesRoute;

  constructor(
    private _loadingTrackerService: LoadingTrackerService,
    private _futuresModeService: FuturesModeService,
  ) {}
}
